import React from 'react';

export const WhitePlus = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.2666 7.36686H8.63329V3.73353C8.63329 3.3839 8.34958 3.1002 7.99995 3.1002C7.65032 3.1002 7.36662 3.3839 7.36662 3.73353V7.36686H3.73328C3.38366 7.36686 3.09995 7.65057 3.09995 8.0002C3.09995 8.34982 3.38366 8.63353 3.73328 8.63353H7.36662V12.2669C7.36662 12.6165 7.65032 12.9002 7.99995 12.9002C8.34958 12.9002 8.63329 12.6165 8.63329 12.2669V8.63353H12.2666C12.6162 8.63353 12.9 8.34982 12.9 8.0002C12.9 7.65057 12.6162 7.36686 12.2666 7.36686Z"
                fill="#F5F5F5"
                stroke="#F5F5F5"
                strokeWidth="0.2"
            />
        </svg>
    );
};
